module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAASCAYAAAB8fn/4AAAAAXNSR0IArs4c6QAAAEJJREFUGBljZHj5KICB4X89w38GAQZGxkJGhhcPHwAZ8gxg8P8CE4QBIxkZmYCyBUDuRYb//x8C6QaYFAk049C1FgBmZCsbrj4GbgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme1/column.png
// module id = pNpb
// module chunks = 78